import { Dialog, Divider, Stack, Typography, Box } from "@mui/material";
import GoogleLoginButton from "../GoogleLoginButton";
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';

type LoginDialogProps = {
    open: boolean;
    onClose: () => void;
}

const LoginDialog = ({ open, onClose }: LoginDialogProps) => {
    return (
        <Dialog
            open={open}
            onClose={onClose}
            PaperProps={{
                sx: {
                    borderRadius: 3,
                    p: 4,
                    pb: 6,
                    width: 280,
                }
            }}
        >
            <Stack gap={3} alignItems="center">
                {/* Icon Avatar */}
                <Box
                    sx={{
                        width: 50,
                        height: 50,
                        borderRadius: '50%',
                        backgroundColor: 'primary.main',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        mb: 1
                    }}
                >
                    <LockOutlinedIcon sx={{ color: 'white', fontSize: 28 }} />
                </Box>

                <Typography
                    variant="h5"
                    fontWeight="bold"
                    textAlign="center"
                >
                    Welcome Back
                </Typography>

                <Typography
                    variant="body1"
                    color="text.secondary"
                    textAlign="center"
                    sx={{ maxWidth: 300 }}
                >
                    Sign in to access your todos and workspaces
                </Typography>

                <Box sx={{ width: '100%', position: 'relative', my: 1 }}>
                    <Divider>
                        <Typography variant="body2" color="text.secondary" sx={{ px: 2 }}>
                            Continue with
                        </Typography>
                    </Divider>
                </Box>

                <Stack gap={2} width="100%" alignItems="center" sx={{ px: 2 }}>
                    <GoogleLoginButton />
                    <Typography
                        variant="caption"
                        color="text.secondary"
                        sx={{ mt: 1, textAlign: 'center' }}
                    >
                        By continuing, you agree to our Terms of Service and Privacy Policy
                    </Typography>
                </Stack>
            </Stack>
        </Dialog>
    )
}

export default LoginDialog;
